import React, { Component } from 'react'
import { Layout, Button } from "antd";

import Events from "../../services/events";

import Feed from "../Feed"

import FilterPanel from "../../components/Modules/FilterPanel";
import PageHeader from "../../components/Modules/PageHeader";

const { Content } = Layout;

export default class PastEvents extends Component {
  state = {
    userClaims: {},
    message: null
  };

  async componentDidMount() {
    this.setFilters();
  }

  setFilters() {
    // Events.setFilter('events', 'past');
    Events.setSort('time', 'desc')
  }

  filterBy(field, value) {
    Events.setFilter(field, value);
    this.setState({refresh: Math.random()})
  }

  render() {
    const { events } = this.props;
    const { type } = this.props.params;
    const list = events.filter(event => event.type === type);

    return(
      <Layout className="page-wrapper">
        <Content className="feed">
          <PageHeader
            className="header"
            title={type || "Surgeries"}
            isHideBackButton={true}
            extra={
              <div className="search-form">
                <FilterPanel
                  filter={this.filterBy}
                  title="Search all"
                  type="all"
                  deviceType
                />
              </div>
            }
            extraMobile={
              <Button type="primary" shape="circle" icon="search" />
            }
            mobileTitleSearch="Search all"
            mobileTypeSearch="all"
          />

          <Feed
            list={list}
            location ={ this.props.location }
            renderType={"events"}
            eventType={"past"}
          />
        </Content>
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/PastEvents/index.js